import Card from "@/components/card"
import TextInput from "@/components/text-input"
import Space from "@/components/space"
import Button from "@/components/button"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { getLegalIdentifier } from "@/redux/account.types"
import { accountEdit, accountRisksSettingsEdit, accountRisksSettingsSet, accountUpdate } from "@/redux/account.actions"
import { faSave } from "@fortawesome/free-solid-svg-icons"
import { t } from "i18next"
import { useState } from "react"
import { toast } from "react-toastify"

export default function AccountRisksSettingsForm() {
  const dispatch = useAppDispatch()
  const account = useAppSelector((state) => state.account.active)
  const status = useAppSelector((state) => state.account.status)
  const settings = useAppSelector((state) => state._session.accountRisksSettings)
  //Compte sans reglages (module jamais configure) : la sauvegarde les cree, avec les valeurs par defaut de la session
  const [isCreating] = useState(!account.accountRisksSettings)
  const [isDirty, setIsDirty] = useState(isCreating)

  const updateField = (key: string) => ({ value }: { value: any }) => {
    dispatch(accountRisksSettingsEdit({ key, value }))
    setIsDirty(true)
  }

  const handleSave = async () => {
    if (!account.name) {
      toast(t("Merci de remplir le nom du compte"))
      return
    }
    if (isCreating) dispatch(accountRisksSettingsSet(settings))
    await dispatch((_, getState) => dispatch(accountUpdate(getState().account.active)))
    setIsDirty(false)
  }

  return (
    <Card title={t("Informations du compte")}>
      <div className="flex gap-4 items-end">
        <TextInput
          type="text"
          title={t("Nom du compte")}
          value={account.name}
          onChange={({ value }: { value: string }) => {
            dispatch(accountEdit("name", value))
            setIsDirty(true)
          }}
          required
        />
        <TextInput
          title={t("Identifiant légal")}
          type="text"
          value={getLegalIdentifier(settings)}
          onChange={updateField("legalIdentifier")}
        />
      </div>
      <Space />
      <div className="flex mt-4">
        <Space />
        <Button
          width={164}
          isLoading={status === "STATUS_SAVING"}
          onClick={isDirty ? handleSave : undefined}
          icon={faSave}
          className={isDirty && account.name ? "primary" : "light"}
          isWithBorder>
          {t("utils_save")}
        </Button>
      </div>
    </Card>
  )
}
